import React, {Component} from 'react';
import PropTypes from 'prop-types';
import PureRenderMixin from 'react-addons-pure-render-mixin';
import classnames from 'classnames';
import Sprite from 'sprite-component';
import AutoSuggestItem from './AutoSuggestItem';

class AutoSuggestList extends Component {
    constructor(props) {
        super(props);

        this.shouldComponentUpdate = PureRenderMixin.shouldComponentUpdate.bind(this);
    }

    _generateDataTestId(prefix, purpose) {
        if (typeof purpose === 'undefined') {
            return `${prefix}-default`;
        } else {
            return `${prefix}-${purpose}`;
        }
    }

    render() {
        const {
            hidden,
            suggestions,
            activeSuggestion,
            onSuggestionSelect,
            onSuggestionMouseDown,
            onSuggestionMouseOut,
            showPoweredByGoogle,
            dataTestIdPurposeForList,
            dataTestIdPurposeForItem
        } = this.props;
        const classes = classnames(
            'AutoSuggestInput-suggestions',
            {'AutoSuggestInput-suggestions-hidden': hidden}
        );
        const dataTestId = this._generateDataTestId('AutoSuggestList-list', dataTestIdPurposeForList)

        return (
            <ul className={classes} data-testid={dataTestId}>
                {suggestions.map((suggestion, i) => {
                    const {
                        id,
                        placeId,
                        className
                    } = suggestion;
                    const active = placeId ? activeSuggestion && placeId === activeSuggestion.placeId : activeSuggestion && id === activeSuggestion.id;

                    return (
                        <AutoSuggestItem
                            key={(id) ? id : placeId ? placeId : i}
                            className={className}
                            suggestion={suggestion}
                            active={active}
                            onSuggestionSelect={() => onSuggestionSelect({
                                suggestion
                            })}
                            onSuggestionMouseDown={onSuggestionMouseDown}
                            onSuggestionMouseOut={onSuggestionMouseOut}
                            dataTestIdPurposeForItem={dataTestIdPurposeForItem}
                        />
                    );
                })}
                {showPoweredByGoogle &&
                    <li className="AutoSuggestInput-item powered-by-google">
                        <Sprite name="powered-by-google" />
                    </li>
                }
            </ul>
        );
    }
}

AutoSuggestList.propTypes = {
    hidden: PropTypes.bool,
    suggestions: PropTypes.array,
    activeSuggestion: PropTypes.object,
    onSuggestionSelect: PropTypes.func.isRequired,
    onSuggestionMouseDown: PropTypes.func,
    onSuggestionMouseOut: PropTypes.func,
    showPoweredByGoogle: PropTypes.bool,
    dataTestIdPurposeForList: PropTypes.string,
    dataTestIdPurposeForItem: PropTypes.string
};

AutoSuggestList.defaultProps = {
    hidden: true,
    suggestions: [],
    showPoweredByGoogle: false
};

export default AutoSuggestList;



// WEBPACK FOOTER //
// ./frontend/src/js/components/auto-suggest/AutoSuggestList.jsx